import { cr } from "fire-wind-water";

class SkfClassName {
  attr: string;
  exp: any;
  $value: any;
  $index: number;
  constructor(private elem, private field: any) {
    this.attr = this.elem.getAttribute("skf-class");
    if (/\$value/.test(this.attr)) {
      const optionIndex = parseInt(this.elem.getAttribute("skf-options"), 10);
      this.$value = this.field.listOptions[optionIndex];
      this.$index = optionIndex;
    }
    if (/\$index/.test(this.attr)) {
      const optionIndex = parseInt(this.elem.getAttribute("skf-options"), 10);
      this.$index = optionIndex;
    }
    this.exp = new Function(
      "const $field = this.field; const $value = this.$value; const $index = this.$index; return " +
        this.attr
    );
  }

  update(): void {
    const value = this.exp.call(this);
    if (cr.isString(value)) {
      this.elem.className = value;
    } else if (cr.isPlainObject(value)) {
      const str: string[] = [];
      cr.each(value, (d, k) => {
        if (d) {
          str.push(k);
        }
      });
      this.elem.className = str.join(" ");
    }
  }
}

export { SkfClassName };
